import { render, staticRenderFns } from "./modalProformaInvoiceEdit.vue?vue&type=template&id=127e1a8c&scoped=true"
import script from "./modalProformaInvoiceEdit.vue?vue&type=script&lang=js"
export * from "./modalProformaInvoiceEdit.vue?vue&type=script&lang=js"
import style0 from "./modalProformaInvoiceEdit.vue?vue&type=style&index=0&id=127e1a8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "127e1a8c",
  null
  
)

export default component.exports